// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"dictionaryProvider_mulitpleDropdown__1BkWT","loaderWrapper":"dictionaryProvider_loaderWrapper__2z9vV"};